<template>
    <li><a :href="item.link" target="_blank">{{item.label}}</a></li>
</template>
<script>
    export default {
        name: 'LinkItem',
        props: ['item']
    }
</script>
